import { render, staticRenderFns } from "./Topicos.vue?vue&type=template&id=4c7b7f99&scoped=true"
import script from "./Topicos.vue?vue&type=script&lang=js"
export * from "./Topicos.vue?vue&type=script&lang=js"
import style0 from "./Topicos.vue?vue&type=style&index=0&id=4c7b7f99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7b7f99",
  null
  
)

export default component.exports